import { Autocomplete, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useData } from "../../hooks/useData";
import { Document, DocumentListResponse } from "../page/DocumentList";

interface Props {
    file?: Document | undefined,
    onChange?: (file: Document | undefined) => void
}

const SearchHeader : React.FC<Props> = ({file, onChange}) => {
    const [documents, setDocuments] = useState([] as Array<Document>);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(undefined as string | undefined);
    const [searchTerm, setSearchTerm] = useState("");
    const docQuery = `documents?${searchTerm ? `startsWith=${searchTerm}&` : ''}startIndex=0&numberOfRows=100`;
    const [lastDocQuery, setLastDocQuery] = useState(`documents`);
    const [getDocumentsApiCall] = useData<DocumentListResponse>(docQuery, "GET", "application/json");

    useEffect(() => {
        if(lastDocQuery !== docQuery && !loading) {
            setLoading(true);
            getDocumentsApiCall((docs) => {
                if(docs && docs?.documentList && docs?.documentList?.length > 0) {
                    setDocuments(docs?.documentList);
                }
                setLastDocQuery(docQuery);
                setLoading(false);
            }, (err) => {
                setError(err);
                setLastDocQuery(docQuery);
                setLoading(false);
            }, undefined);
            
        }
    }, [documents, loading, searchTerm, error, docQuery, lastDocQuery, getDocumentsApiCall]);

    return <>
        <Autocomplete 
            sx={{width: '100%'}} 
            onChange={(e:any, value:Document|null) => {
                if(value) {
                    onChange?.(value);
                }
            }}
            value={file?.id ? file : undefined}
            options={documents}
            renderInput={(params) => <TextField 
                {...params} 
                label="Document"
                name="document"  
                onChange={ev => {
                    if (ev.currentTarget.value !== "" || ev.currentTarget.value !== null) {
                        setSearchTerm(ev.currentTarget.value);
                    }
                  }}
                />}
            getOptionKey={(o) => (o as Document)?.id??""}
            getOptionLabel={(o) => `${(o as Document)?.fileName} | ${(o as Document)?.year} | ${(o as Document)?.language}`}
             />
        {/*<Select sx={{width: '100%'}} name="document" onChange={(e:any) => e?.target?.value && onChange?.(Number.parseInt(e?.target?.value))}>
            {documents.map(d => <MenuItem value={d.id}>{d.fileName}</MenuItem>)}
        </Select>*/}
    </>
}

export default SearchHeader;